import { render, staticRenderFns } from "./IconChip.vue?vue&type=template&id=49ef8839&scoped=true&"
import script from "./IconChip.vue?vue&type=script&lang=js&"
export * from "./IconChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ef8839",
  null
  
)

export default component.exports